<div class="d-flex flex-column submenu-section">
  <span class="fw-bold group-header">HISTORICAL DATA</span>
  <!-- Historical data routes -->
  <ng-container *ngTemplateOutlet="historicalDataNavItemTemplate"></ng-container>
  <span class="fw-bold group-header">OTHER</span>
  <!-- Other routes -->
  <ng-container *ngTemplateOutlet="patientAppointmentNavItemTemplate"></ng-container>
</div>

<ng-template #historicalDataNavItemTemplate>
  @for (historicalDataNavItem of historicalDataNavItems; track $index) {
  @if (isNavExpanded) {
  <mat-list-item (click)="openHistoricalDataModal(historicalDataNavItem)" onKeyDown="doNothing();" tabindex="0" class="nav-list-item subheading sub-items"
    [ngClass]="isNavExpanded ? 'expaned-nav' : 'collapsed-nav'" cvaAuthPermCheck
    [moduleName]='historicalDataNavItem.authModule' [permissionType]='CVA_CONSTANTS.PERMISSION.READ'
    [actionType]='"hide"'>
    <div class="mat-list-item d-flex align-items-center">
      <mat-icon class="arrow-icon">arrow_right</mat-icon>
      <label class="subheading-label" for="historicalData">{{historicalDataNavItem.title}}</label>
    </div>
  </mat-list-item>
  } @else {
  <button type="button" mat-menu-item (click)="openHistoricalDataModal(historicalDataNavItem)" class="fs-6 subLabel" cvaAuthPermCheck
    [moduleName]='historicalDataNavItem.authModule' [permissionType]='CVA_CONSTANTS.PERMISSION.READ'
    [actionType]='"hide"'>
    <mat-icon class="arrow-icon">arrow_right</mat-icon> {{ historicalDataNavItem.title }}
  </button>
  }
  }
</ng-template>

<ng-template #patientAppointmentNavItemTemplate>
  @if (isNavExpanded) {
  <mat-list-item (click)="openPatientAppointment()"  onKeyDown="doNothing();" tabindex="0"  class="nav-list-item subheading sub-items"
    [ngClass]="isNavExpanded ? 'expaned-nav' : 'collapsed-nav'" cvaAuthPermCheck
    [moduleName]='CVA_AUTH_MODULES.CVA_APPOINTMENT' [permissionType]='CVA_CONSTANTS.PERMISSION.READ'
    [actionType]='"hide"'>
    <div class="mat-list-item d-flex align-items-center">
      <mat-icon class="arrow-icon">arrow_right</mat-icon>
      <label class="subheading-label" for="historicalData">Appointments</label>
    </div>
  </mat-list-item>
  } @else {
  <button type="button" mat-menu-item (click)="openPatientAppointment()" class="fs-6 subLabel" cvaAuthPermCheck
    [moduleName]='CVA_AUTH_MODULES.CVA_APPOINTMENT' [permissionType]='CVA_CONSTANTS.PERMISSION.READ'
    [actionType]='"hide"'>
    <mat-icon class="arrow-icon">arrow_right</mat-icon> Appointments
  </button>
  }
</ng-template>